import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"30\" height=\"30\" x=\"30\" y=\"30\" fill=\"#fff\" fill-opacity=\".5\" rx=\"15\" transform=\"rotate(-180 30 30)\"></rect><mask id=\"a\" width=\"26\" height=\"26\" x=\"2\" y=\"2\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:alpha;\"><path fill=\"#D9D9D9\" d=\"M28 28H2V2h26z\"></path></mask><g mask=\"url(#a)\"><path fill=\"#1B2021\" d=\"m15 10.775 6.5 6.5-1.517 1.517L15 13.808l-4.983 4.984L8.5 17.275z\"></path></g>", 3)
  ])))
}
export default { render: render }